<script lang="ts" setup>
import { LayoutSider } from '../../ui-settings';
</script>

<template>
  <div style="height: 100vh; position: relative">
    <n-layout
      position="absolute"
      has-sider
      class="default-layout"
    >
      <LayoutSider class="main-sider">
        <slot name="sider" />
      </LayoutSider>
      <n-layout-content
        class="main-content"
        :native-scrollbar="false"
        content-style="padding: 24px;"
      >
        <div
          container
          mx-auto
        >
          <slot />
        </div>
      </n-layout-content>
    </n-layout>
  </div>
</template>

<style>
.default-layout {
  min-height: 100vh;
  max-height: 100vh;
}

.default-layout .main-sider,
.default-layout .main-content {
  min-height: 100vh;
  max-height: 100vh;
}

.n-layout.n-layout--absolute-positioned.main-content {
  top: 0;
  bottom: 0;
}
</style>
